<!--read:批阅页面 2023/08/31 18:39:17 YuAng-->

<template>
  <div class="marking-read" :style="{ backgroundColor: setting.eyeSave ? '#C7EDCC' : '#F1F3F7' }">
    <!-- 这里隐藏三张canvas需要的图标 -->
    <p v-show="false">
      <img :src="require('../assets/img/' + item + '.png')" v-for="item in canvasImages" :key="item" :id="item" alt="canvas" title="canvas" />
    </p>
    <div class="read-ques-list">
      <div v-for="item, index in toDoQuestions" :key="'ques' + index">
        <!-- header -->
        <div class="read-ques-infos">
          <p class="ques-no">
            <span>题号：{{ quesNumLabel(item.stand) }}</span>
            <template v-if="not1018">
              <span class="span-round-btn">个人平均分：<b style="color: #5098f8;">{{ teacherAvgScore }}分</b></span>
              <span class="span-round-btn" v-if="examConfig.showAverageScore">小组平均分：<b style="color: #E6A23C;">{{
                questionAvgScore }}分</b></span>
              <span class="span-round-btn" v-if="examConfig.showStudentInfo && currStudentName.length > 0">学生姓名：{{
                currStudentName }}</span>
            </template>

            <span v-show="(item.gradingTodo.score || item.gradingTodo.score === 0)" class="span-round-btn">该题总得分：<b style="color: #5098f8;">{{ item.gradingTodo.score }}</b></span>
          </p>
          <p v-if="(setting.readType == 2 || setting.readType == 3) && item.teaScoreVos" class="ques-no">
            <span>批改记录：</span>
            <span style="font-weight: bold; color: #5098f8" v-for="remark, index in item.teaScoreVos" :key="remark.id">
              {{ remark.name }}:{{ remark.score }}分<i v-show="index < item.teaScoreVos.length - 1">、</i>
            </span>
          </p>
          <p v-if="setting.readType == 4" class="ques-no">
            <span>提交人：{{ item.doubtRecordTeacher }} </span>
            <span @click="viewImage(item.originalUrl)" class="ques-big-pic">查看大图</span>
          </p>
          <!-- 多张图的时候展示横竖排的操作 -->
          <div v-if="item.images && item.images.length > 1" class="ques-pic-set">
            <span :class="{ active: setting.picDisplay === 'vertical' }" class="vertical" @click="setting.picDisplay = 'vertical'" style="margin-right: 16px;">竖排</span>
            <span :class="{ active: setting.picDisplay === 'horizontal' }" class="horizontal" @click="setting.picDisplay = 'horizontal'">横排</span>
          </div>
        </div>
        <!-- 图片 -->
        <div class="pic-dom" :class="setting.picDisplay">
          <mark-image v-for="img, jIndex in item.images" :key="item.gradingTodo.resultDetailId + 'image' + jIndex" :img="img" :setting="setting" @mark-score="markScore">
            <div v-if="showRawPaper" :style="iconStyle(img)">
              <el-tooltip effect="dark" content="查看原卷" trigger="hover" placement="top-end">
                <div class="paper-preview" @click="viewMosaic(toDoItem.current)">
                  <i class="el-icon-search"></i>
                </div>
              </el-tooltip>
            </div>
          </mark-image>
        </div>
      </div>
    </div>
    <!-- 利用el-image实现代码控制预览图片 -->
    <el-image class="preview-img" ref="preview" :src="previewImg.src" :preview-src-list="[previewImg.src]"></el-image>
    <yue-drag-answer ref="answer" v-show="setting.showStandAnswer" :item="toDoItem"></yue-drag-answer>
    <yue-drag-set-score ref="setScore" :item="toDoItem" :setting="setting" @set-score="submitScore" :user="userInfo">
      <div v-show="setting.setComment">
        <p class="read-mark-types">
          <span v-for="item in markTypes" :key="item.type" @click="setting.drawType = item.type" class="set-btn" :class="{ active: item.type === setting.drawType }">
            {{ item.label }}
          </span>
        </p>
        <p class="read-mark-actions">
          <span class="set-btn" @click="cancelAction">撤销上一步</span>
          <span class="set-btn" @click="clearAction">清空全部批注</span>
        </p>
      </div>
    </yue-drag-set-score>
    <yue-drag-select-score v-if="toDoItem.current" ref="selectScore" v-show="setting.scoreSetCustom" @set-score="submitSelectScore" :max-score="toDoItem.current.stand.point" style="z-index: 101;"></yue-drag-select-score>
    <yue-read-set ref="set" :setting="setting"></yue-read-set>
    <input style="position: fixed;width: 50px;left: -150px;" placeholder="点击给分input" id="temInput" ref="temInput" @keyup.enter="enterSubmit" />
  </div>
</template>
<script>
import util from '@/v2/utils/util'
import { networkApi } from '@/utils/api';
import { configApi } from '@/api/api';
import { gradingApi } from '@/v2/utils/api'
import { networkData } from '@/utils/data';
import { mapGetters } from "vuex";
import { xDraw } from '@/utils/draw.js'
import MarkImage from './components/MarkImage.vue';
export default {
  name: 'read',
  data () {
    return {
      list: [],
      setting: {
        readType: 4,
        visible: false,
        scoreSetMark: false,
        scoreSetCustom: false,
        scale: 1.4,
        halfScore: false,
        toDoScore: 'reset',
        beginTime: +new Date(),
        pageNum: 0,
        twoRead: false,
        markType: '',
        fullScreen: true,
        showStandAnswer: false,
        expandArea: false,
        setComment: false,
        drawType: 'select',
        picDisplay: 'vertical',
        canSetScore: true,
        eyeSave: false // 开启护眼模式
      },
      toDoQuestions: [],
      toDoItem: { children: [], stand: { point: 0 }, current: { stand: { point: 0 } } },
      beginTime: Date.now(),
      previewImg: { src: '' },
      showRawPaper: false,
      score: null,
      questionAvgScore: 0,
      teacherAvgScore: 0,
      markTypes: xDraw.getTools(),
      canvasImages: xDraw.canvasImages,
      examConfig: {  // 考试配置
        showAverageScore: false, // 是否显示小组平均分
        showStudentInfo: false, // 是否显示学生信息
      },
      isClassMark: false, // 是否班级批阅
      tabs: [],
      currStudentName: '',
      markTypeDict: util.markTypeDict,
      not1018: true
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      headerStatus: "getHeaderStatus",
    })
  },
  mounted () {
    this.initData()
  },
  methods: {
    quesNumLabel: util.quesNumLabel,
    initData () {
      // 获取试题配置信息（展示姓名/小题分）
      this.getExamSet()
      // 获取批阅模式
      this.getAssignMode()
      // 预览原卷
      this.lookRawPaper()
    },
    getExamSet () {
      if (this.$route.query.isMore.indexOf('SCHOOL') >= 0) {
        gradingApi.getReview(this.getGeneralParams()).then(resp => {
          if (resp.success) {
            const config = resp.body || this.examConfig
            this.examConfig.showAverageScore = (config.showAverageScore || 0) === 1
            this.examConfig.showStudentInfo = (config.showStudentInfo || 0) === 1
          } else {
            this.$message.warning(resp.message)
          }
        })
      } else {
        this.examConfig.showAverageScore = true
      }
    },
    // 获取批阅方式
    getAssignMode () {
      gradingApi.getAssignMode(this.getGeneralParams()).then(resp => {
        if (resp.success) {
          this.isClassMark = resp.body ? resp.body === 'CLASS' : false
          this.initQuestionList()
        } else {
          this.$message.warning(resp.message)
        }
      })
    },
    cancelAction: function () {
      xDraw.cancelAction()
    },
    clearAction: function () {
      xDraw.clearAction()
    },

    submitSelectScore (info) {
      if (this.toDoItem.isError) {
        return this.$message.warning('疑问卷无法设置分数!');
      }
      const list = this.toDoItem.children;
      if (list && list.length) {
        const row = this.toDoItem.current;
        row.gradingTodo.score = info.score;
        const index = list.indexOf(row);
        if (index + 1 < list.length) {
          this.toDoItem.current = list[index + 1];
        }
        if (index < list.length - 1) {
          return;
        }
      }
      info.direct = true;
      this.submitScore(info);
    },
    async submitScore (info) {
      // 如果正在提交，则不重复提交
      if (info.direct === false || this.setting.submiting) {
        return;
      }
      const toast = this.$message.warning({ message: '获取题目中...', duration: 0 })
      this.setting.submiting = true
      // 打标记开关闭，清空数据
      if (this.setting.scoreSetMark) {
        const restult = this.checkScoreMarks()
        if (!restult) {
          this.setting.submiting = false
          toast.close()
          return
        }
      } else {
        this.removeScoreMarks()
      }

      this.toDoItem.gradingTodo.score = info.score;

      const { diffValue, version, judgeType } = this.setting.group

      const { groupId, pauseStatus, type, whetherCombine, gradingTodo, goodAnswer, gradingDetailId, isError, isReview, updateGradingDetailId, questionSplitVos, isSplit } = this.toDoItem;

      let temItem = {
        detailId: gradingTodo.resultDetailId,
        goodAnswer: goodAnswer ? 1 : 0,
        gradingDetailId,
        groupId,
        isAbnormal: isError ? 1 : 0,
        isReview,
        num: gradingTodo.num,
        ossUrl: gradingTodo.ossUrl,
        question: gradingTodo.question,
        pauseStatus,
        resultId: gradingTodo.resultId,
        score: gradingTodo.score,
        todoId: isReview ? null : gradingTodo.id,
        updateGradingDetailId,
        whetherCombine,
        questionSplitVos: questionSplitVos || [],
        isSplit
      };
      if (isError) {
        temItem.score = -1;
        // 如果存在小题，打疑问卷的时候，其小题所有分数也要设置为-1
        if (temItem.questionSplitVos) {
          for (let index = 0; index < temItem.questionSplitVos.length; index++) {
            const sQues = temItem.questionSplitVos[index];
            sQues.gradingScore = temItem.score;
          }
        }
      }
      else if (temItem.questionSplitVos.length) {
        let totalScore = 0;
        for (let index = 0; index < temItem.questionSplitVos.length; index++) {
          const sQues = temItem.questionSplitVos[index];
          const item = this.toDoItem.children[index];
          if (item.gradingTodo.score === null) {
            sQues.gradingScore = -1;
          } else {
            sQues.gradingScore = parseFloat(item.gradingTodo.score);
            totalScore = totalScore + sQues.gradingScore;
          }
        }
        temItem.score = totalScore;
      }

      if (temItem.score === null) {
        this.$message.warning('该题打分失败，请重新打分')
        window.SlsSend({
          action: 'submitScore',
          desc: 'temItem.score is null',
          data: this.toDoItem
        })
        return
      }

      const groupExamQuestionVos = [{ groupId, type, examQuestionVos: [temItem] }];

      const params = {
        examId: this.$route.params.id,
        gradingTime: +new Date() - this.beginTime,
        schoolId: this.$route.query.schoolId,
        judgeType,
        version,
        groupExamQuestionVos: groupExamQuestionVos,
      };

      if (params.groupExamQuestionVos && params.groupExamQuestionVos.length <= 0) {
        this.$message.warning('获取试题信息失败！请刷新页面再次尝试。')
        return
      }

      // 检测分值 仲裁教师检测
      if (this.setting.readType === 2 && this.toDoItem.teaScoreVos) {
        // 一次遍历同时计算最高分和最低分
        const scoreList = this.toDoItem.teaScoreVos.map(item => item.score)
        const maxScore = Math.max(...scoreList)
        const minScore = Math.min(...scoreList)
        if ((info.score > maxScore && info.score - maxScore > diffValue) || (info.score < minScore && minScore - info.score > diffValue)) {
          this.$message.warning(`温馨提示：您打的分数${info.score}分与一评二评有明显偏差，如需修改可回评进行修改`)
        }
      }
      // 根据是否是初次提交，选择不同的接口
      const promise = this.pageNum === 0 ? gradingApi.readOver : gradingApi.updateReadOver;
      const resp = await promise(params)
      if (resp.success) {
        this.updateReadMark();
        await this.loadQuesYueReadSet();
      } else {
        this.$message.error(resp.message);
        if (resp.code === 666) {
          await this.loadQuesYueReadSet();
        }
      }
      this.setting.submiting = false
      toast.close()
    },
    getTypesYueReadSet () {
      const params = {
        teacherId: this.userInfo.userId,
        schoolId: this.$route.query.schoolId,
        examId: this.$route.params.id,
      };
      return networkApi.getWuHenRole(params).then(resp => {
        if (!resp || (resp.body && resp.body.length === 0)) {
          return this.$router.replace("/exam/marking/error");
        }
        return resp;
      });
    },
    setTypeYueReadSet (info) {
      this.setting.readType = info.readType;
      this.pageNum = 0;
      this.loadGroups();
    },
    loadGroups () {
      let key = 'FIRST'
      if (this.markTypeDict) {
        key = Object.keys(this.markTypeDict)[this.setting.readType - 1] || 'FIRST'
      }

      if (this.tabs && this.tabs.length > 0) {
        const tab = this.tabs.find(item => item.type === key);
        if (tab && tab.detailList.length > 0) {
          this.$refs.set.setList(tab.detailList);
        } else {
          return this.alertEmpty(0);
        }
      }
    },
    async loadQuesYueReadSet (pageSize = 0) {
      this.beginTime = +new Date()
      this.toDoQuestions = [];
      this.pageNum = pageSize === 0 ? 0 : this.pageNum + pageSize > 0 ? this.pageNum + pageSize : 0;
      const params = {
        ...this.getGeneralParams(),
        currentPage: this.pageNum
      };
      if (this.setting.group) {
        params.previewDetail = this.setting.group;
      }
      this.toDoItem.children = [];
      xDraw.resetAction()
      const resp = await gradingApi.getQuestionItem(params)
      if (resp) {
        this.$refs.set.loadQuesProgress()
        if (resp.success) {
          this.list = resp.body;
          if (resp.toDoQuestions && resp.toDoQuestions.length) {
            this.emptyCount = null;
            this.toDoQuestions = resp.toDoQuestions;
            let toDoItem = resp.toDoItem
            toDoItem.showError = !this.isClassMark
            this.toDoItem = toDoItem
            this.loadReadAvg(resp.toDoItem)
            this.initStudent()
            this.$nextTick(() => {
              this.toDoItem.current = resp.toDoItem.current;
            });
          }
          else {
            return this.alertEmpty(pageSize);
          }
        } else {
          this.$message.error(resp.message);
        }
      } else {
        this.$message.error('获取题目信息失败！请刷新页面再次尝试。')
      }
      this.setting.submiting = false
    },
    initStudent () {
      const gradingTodo = this.toDoItem.gradingTodo
      if (gradingTodo && this.examConfig.showStudentInfo) {
        const params = { examId: gradingTodo.examId, resultIds: gradingTodo.resultId }
        gradingApi.getReviewStudentName(params).then(resp => {
          if (this.not1018) {
            this.not1018 = resp.code !== 1018
          }
          if (resp.success) {
            this.currStudentName = resp.body.length > 0 ? resp.body[0].studName : ''
          } else {
            this.$message.warning(resp.message)
          }
        })
      }
    },
    getMarkScore: async function () {
      const ques = this.toDoItem.current
      // ques 为空 或 新题时，不需要获取标记信息
      if (!ques || this.pageNum === 0) return
      const params = {
        examId: this.$route.params.id,
        teacherId: this.userInfo.userId,
        gradingType: this.setting.readType,
        detailId: this.toDoItem.gradingTodo.resultDetailId
      };
      const resp = await gradingApi.getReadMark(params, ques)
      // 如果曾经是“点击给分”，自动开启标记视图
      if (resp.body) {
        // 只有痕迹坐标不为零点，才认为是“点击给分”模式
        const list = resp.body.filter(item => item.position !== '0,0')
        if (list.length > 0) {
          this.setting.scoreSetMark = true
          if (list[0].isRight) {
            this.setting.markType = 'add'
          } else {
            this.setting.markType = 'del'
          }
        }
      }
    },
    removeScoreMarks: function () {
      const currentQuestion = this.toDoItem.current
      for (let index = 0; index < currentQuestion.images.length; index++) {
        // 从数据结构移除
        const img = currentQuestion.images[index];
        img.scores = []
        if (!img.canvas) continue
        const objects = img.canvas.getObjects()
        // 从画布移除
        for (let index = 0; index < objects.length; index++) {
          const item = objects[index];
          if (item.id) {
            img.canvas.remove(item)
          }
        }
      }
    },
    checkScoreMarks: function () {
      const allObjects = this.getMarkObjects()
      for (let index = 0; index < allObjects.length; index++) {
        const item = allObjects[index];
        if (item.objects.reduce((sum, score) => sum + score, 0) !== item.scores.reduce((sum, score) => sum + score, 0)) {
          window.SlsSend({
            action: 'checkScoreMarks',
            desc: '检查标记分数与当前打分不一致',
            data: item
          })
          this.$confirm('标记分数与当前打分不一致，请重新打分', '提示').then(() => {
            location.reload()
          }).catch(() => { });
          return false
        }
      }
      return true
    },
    getMarkObjects: function () {
      const currentQuestion = this.toDoItem.current
      const allObjects = []
      for (let index = 0; index < currentQuestion.images.length; index++) {
        const img = currentQuestion.images[index];
        if (!img.canvas) continue
        const objects = img.canvas.getObjects().map(item => item.id ? parseFloat(item.text) : 0)
        const scores = img.scores.filter(item => item.id && item.id.indexOf('_0_0') === -1 && !item.jsonUrl).map(item => item.value)
        allObjects.push({
          objects,
          scores
        })
      }
      // console.log(allObjects)
      return allObjects
    },
    updateReadMark: function () {
      // 如果是第一次，且不是“点击给分”，且不是“加批注”, 那么不需要保存痕迹
      if (this.pageNum === 0 && !this.setting.scoreSetMark && !this.setting.setComment) {
        return
      }
      const params = {
        examId: this.$route.params.id,
        teacherId: this.userInfo.userId,
        gradingType: this.setting.readType,
        detailId: this.toDoItem.gradingTodo.resultDetailId,
        schoolId: this.toDoItem.gradingTodo.schoolId,
        num: this.toDoItem.gradingTodo.num,
        ossUrl: this.toDoItem.gradingTodo.ossUrl
      };
      gradingApi.updateReadMark(params, this.toDoItem);
    },
    updateAssignYueReadSet (list) {
      const closeList = [];
      const startList = [];
      list.forEach(item => {
        item.questionNums = item.questionNums.map((q) => {
          if (q.assignType === 2) {
            const item = {
              teacherId: this.userInfo.userId,
              schoolId: this.$route.query.schoolId,
              examId: this.$route.params.id,
              num: q.num,
              question: q.question,
            };
            if (q.gradStatus && !q.gradStatusNew) {
              closeList.push(item);
            }
            if (!q.gradStatus && q.gradStatusNew) {
              startList.push(item);
            }
          }
        });
      });
      networkApi.updateTeaGrading({
        closeTeaGradingStatusVos: closeList,
        startTeaGradingStatusVos: startList,
      }).then(resp => {
        if (resp.code == 200) {
          this.loadGroups();
        }
        else {
          this.$message.error(resp.message);
        }
      });
    },
    alertEmpty (pageSize) {
      let empty = '暂无待批阅的题目';
      if (pageSize) {
        empty = '未查询到题目';
      }
      this.toDoQuestions = []
      this.toDoItem = { children: [], stand: { point: 0 }, current: { stand: { point: 0 } } }
      return this.$confirm(empty, "提示", { type: "warning", confirmButtonText: "返回" }).then(() => {
        document.body.querySelector('.close-read').click();
      }).catch(() => { });
    },
    getProgressYueReadSet (info) {
      this.progressLoading = true;
      let params = {
        examId: this.$route.params.id,
        schoolId: this.$route.query.schoolId,
        num: info.num,
        judgeType: info.judgeType,
        groupId: info.groupId,
      };

      return gradingApi.getQuestionSchedule(params);
    },
    jump2YueReadSet () {
      const topic = this.toDoItem.num || this.$route.query.num
      if (!topic) {
        return this.$message.error('当前没有题目');
      }
      const query = {
        topic: topic,
        readType: this.setting.readType,
        examId: this.$route.params.id,
        schoolId: this.$route.query.schoolId,
        isMore: this.$route.query.isMore
      }
      this.$router.push({ path: '/exam/marking/paperReview', query })
    },
    loadYueDragAnswer () {
      return networkApi.listSubjectStand({
        examId: this.$route.params.id,
      });
    },
    loadReadAvg (item) {
      this.questionAvgScore = 0
      this.teacherAvgScore = 0
      const params = {
        examId: this.$route.params.id,
        num: item.num,
        isAll: this.examConfig.showAverageScore
      }
      networkApi.getReadAvg(params).then(resp => {
        if (resp.body) {
          this.teacherAvgScore = resp.body.teacherAvgScore
          this.questionAvgScore = resp.body.questionAvgScore
        }
        if (this.not1018) {
          this.not1018 = resp.code !== 1018
        }
      })
    },
    viewImage (src) {
      this.previewImg.src = src;
      this.$refs.preview.showViewer = true;
    },
    viewMosaic (item) {
      if (item.mosaicPaperUrl) {
        this.viewImage(item.mosaicPaperUrl);
      } else {
        const todo = item.gradingTodo;
        let params = {
          examId: this.$route.params.id,
          resultId: todo.resultId,
          url: encodeURIComponent(todo.ossUrl.split('?')[0])
        };
        const role = this.$route.query.isMore.indexOf('SCHOOL') >= 0 ? 'school' : 'region'
        networkApi.getStudentMosaicPaper(params, role).then(res => {
          if (res.body && res.body.mosaicUrl) {
            item.mosaicPaperUrl = res.body.mosaicUrl;
            this.viewMosaic(item);
          } else {
            this.$message.error(res.message || '获取学生答题卡失败');
          }
        });
      }
    },
    trySetQuesScore: function (offsetScore) {
      if (offsetScore === 'reset') {
        this.$message.error('请先选中加分或减分批阅的分值')
        return false
      }
      const setting = this.setting
      const currentQuestion = this.toDoItem.current
      // 统计标记分数总和
      let totalMarkScore = offsetScore
      for (let index = 0; index < currentQuestion.images.length; index++) {
        const target = currentQuestion.images[index];
        for (let cIndex = 0; cIndex < target.scores.length; cIndex++) {
          const score = target.scores[cIndex]
          if (score.id && score.id.indexOf('_0_0') === -1 && !score.jsonUrl) {
            totalMarkScore += score.value
          }
        }
      }
      if (setting.markType === 'del') {
        // 如果是减分批阅，当前分为当前题目满分+图片上减分标记之和（减分标记本身为负数）
        totalMarkScore = currentQuestion.stand.point + totalMarkScore
      }
      // 如果是加分批阅，当前分为当前题目图片上加分标记之和
      if (totalMarkScore > currentQuestion.stand.point) {
        this.$message.error('总分值不能超过满分～')
        return false
      }
      if (totalMarkScore < 0) {
        this.$message.error('打分不能为负数～')
        return false
      }
      currentQuestion.gradingTodo.score = totalMarkScore
      return true
    },
    iconStyle (img) {
      if (this.setting.expandArea) {
        return {
          position: 'absolute',
          right: 0,
          bottom: '32px',
        }
      } else {
        return {
          position: 'absolute',
          top: (img.rawHeight * this.setting.scale) - 32 + 'px',
          left: (img.rawWidth * this.setting.scale) + 'px'
        }
      }
    },
    resetDragDiv () {
      if (this.$refs.setScore) {
        this.$refs.setScore.position = { left: '1250px', right: 'auto', top: '120px' }
      }
      if (this.$refs.answer) {
        this.$refs.answer.position = { left: '1200px', right: 'auto', top: '150px' }
      }
      if (this.$refs.selectScore) {
        this.$refs.selectScore.position = { left: '1350px', right: 'auto', top: '180px' }
      }
    },
    enterSubmit () {
      this.$refs.setScore.submitList()
    },
    markScore (info) {
      this.$refs.temInput.value = info.value
      setTimeout(() => {
        this.$refs.temInput.focus()
      }, 0.1 * 1000);
    },
    lookRawPaper () {
      configApi.getConfigByTypes(this.$route.query.schoolId, ['SHOW_PAPER_IN_GRADING']).then(res => {
        if (res.body && res.body.length) {
          this.showRawPaper = parseInt(res.body[0].configValue);
        }
      })
    },
    // 初始化试题集合
    initQuestionList () {
      networkApi.gradingPreviewList(this.getGeneralParams()).then(resp => {
        if (resp.success) {
          this.tabs = resp.body
          this.loadGroups()
        } else {
          this.$message.warning(resp.message)
        }
      })
    },
    // 获取通用参数
    getGeneralParams () {
      return {
        schoolId: this.$route.query.schoolId,
        examId: this.$route.params.id,
      }
    }
  },
  beforeDestroy () {
    networkData.ossClient = null
    document.body.className = "";
    this.$store.dispatch("set_headerStatus", true);
  },
  watch: {
    'setting.fullScreen': {
      immediate: true,
      handler: function () {
        if (this.headerStatus) {
          this.$store.dispatch("set_headerStatus", false);
          document.body.className = 'fullScreen';
        } else {
          this.$store.dispatch("set_headerStatus", true);
          document.body.className = 'fullScreen2';
          this.setting.scale = 0.8
          this.resetDragDiv()
        }
      }
    }
  },
  components: { MarkImage }
}
</script>

<style scoped>
.marking-read {
  height: calc(100vh - 54px);
  overflow: auto;
}

.read-ques-list {
  padding: 20px;
}

.read-ques-infos {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  position: relative;
}

.ques-no {
  line-height: 1.5;
  display: flex;
  align-items: center;
}

.ques-big-pic {
  color: #5098f8;
  cursor: pointer;
  margin-left: 8px;
}

.preview-img ::v-deep .el-image__inner,
.preview-img ::v-deep .el-image__error {
  display: none;
}

.marking-read ::v-deep .read-mark-types {
  margin: 0 10px;
}

.set-btn {
  display: inline-block;
  min-width: 28px;
  padding: 4px 16px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  user-select: none;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
  margin-right: 10px;
  box-sizing: border-box;
}

.read-mark-actions {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  margin-bottom: 10px;
}

.set-btn.active,
.read-mark-actions .set-btn {
  background-color: #5098f8;
  color: white;
  border-color: #5098f8;
}

.pic-dom {
  position: relative;
  display: flex;
  padding-bottom: 50px;
}

.pic-dom.vertical {
  flex-direction: column;
}

.paper-preview {
  transition: visibility 0.2s;
  visibility: hidden;
  position: absolute;
  right: 0;
  width: 32px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 32px;
  font-size: 20px;
  color: #fff;
  border-radius: 2px;
}

.pic-dom:hover .paper-preview {
  visibility: visible;
}

.paper-preview:hover {
  cursor: zoom-in;
}

.ques-pic-set {
  position: absolute;
  left: 600px;
  top: 4px;
  font-weight: normal;
  cursor: pointer;
}

.ques-pic-set span.active::after {
  content: "";
  display: block;
  background-color: #5098f8;
  height: 3px;
  border-radius: 1.5px;
  position: absolute;
  width: 32px;
}

.ques-pic-set .vertical.active::after {
  bottom: -5px;
  left: 0;
}

.ques-pic-set .horizontal.active::after {
  left: auto;
  bottom: -5px;
  right: 0;
}

.span-round-btn {
  background-color: white;
  display: inline-block;
  border-radius: 14px;
  font-size: 13px;
  padding: 4px 20px;
  margin-left: 20px;
  vertical-align: middle;
}

.marking-read ::v-deep .yj-drag .el-icon-s-tools {
  vertical-align: baseline;
}

.marking-read ::v-deep .yj-drag .yj-set-desc {
  line-height: 1.5;
  margin-top: 14px;
}
</style>
<style>
.fullScreen .marking-read {
  height: 100vh;
}

.fullScreen2 .exam-marking-readPaper_route .container {
  padding-top: 54px !important;
}

.fullScreen .exam-marking-readPaper_route .container {
  padding-top: 0 !important;
}
</style>